import { collections } from '@/mocks/homeData';

export default function Collections() {
  return (
    <section id="collections" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        {/* 分区头 */}
        <div className="flex flex-col gap-2">
          <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 索引 · 话题合集</p>
          <h2 className="font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            按话题归档，<span className="text-primary-600">合集</span>先到
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            不再一条条刷。每个方向都有人替你整理成合集——从开头到最新进展，翻一个页面就能补完全部。
          </p>
        </div>

        {/* 合集索引网格 */}
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((c) => (
            <a
              key={c.index}
              href="#community"
              className="group relative overflow-hidden rounded-xl border border-background-200 bg-background-50 p-5 transition hover:border-primary-200 md:p-6"
            >
              <div className="flex items-start justify-between">
                <span className="font-heading text-4xl font-black text-primary-100 transition group-hover:text-primary-300">
                  {c.index}
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
                  <i className="ri-stack-line" />
                  {c.count} 条
                </span>
              </div>

              <span className="mt-5 inline-block rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                #{c.tag}
              </span>
              <h3 className="mt-3 font-medium text-foreground-950 transition group-hover:text-primary-700 md:text-lg">
                {c.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{c.desc}</p>

              <span className="mt-5 flex items-center gap-1.5 text-sm font-medium text-primary-600 opacity-0 transition group-hover:opacity-100">
                进入合集
                <i className="ri-arrow-right-line" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}